/** KPI percentage values use percentage points: 90 means 90 %, as in the POC and API. */
export function formatMetricNumber(value: number, _unit: string, maximumFractionDigits = 2, minimumFractionDigits = 0): string {
  return new Intl.NumberFormat('fr-FR', { maximumFractionDigits, minimumFractionDigits }).format(value);
}

export function formatMetricLabel(value: number, unit: string, maximumFractionDigits = 2, minimumFractionDigits = 0): string {
  const formatted = formatMetricNumber(value, unit, maximumFractionDigits, minimumFractionDigits);
  return unit.trim() === '%' ? `${formatted}%` : unit.trim() ? `${formatted} ${unit.trim()}` : formatted;
}

export function formatMetricValue(value: number, _unit: string, maximumFractionDigits = 4): string {
  return new Intl.NumberFormat('fr-FR', { maximumFractionDigits }).format(value);
}
